import React from 'react';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

const Contact = () => {
  const contactInfo = [
    {
      icon: <MapPin className="w-6 h-6 text-[#D4AF37]" />,
      title: 'Офис адрес',
      details: ['София, България', '(Точен адрес при запитване)']
    },
    {
      icon: <Mail className="w-6 h-6 text-[#D4AF37]" />,
      title: 'Имейл',
      details: ['zaharii.stoyanov@deusestate.com'],
      link: 'mailto:zaharii.stoyanov@deusestate.com'
    },
    {
      icon: <Phone className="w-6 h-6 text-[#D4AF37]" />,
      title: 'Телефон',
      details: ['+359 000 000 000'],
      link: 'tel:+359000000000'
    },
    {
      icon: <Clock className="w-6 h-6 text-[#D4AF37]" />,
      title: 'Работно време',
      details: ['Понеделник - Петък', '09:00 - 18:00']
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20">
      {/* Hero Section */}
      <section className="container-luxury mb-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#111111] border border-[#D4AF37]/20 rounded-full mb-8">
            <span className="text-sm text-[#D4AF37] font-medium tracking-wider">КОНТАКТИ</span>
          </div>
          
          <h1 className="heading-luxury mb-6">
            Свържете се <span className="gradient-text">с нас</span>
          </h1>
          
          <p className="text-xl text-[#A9A9A9] leading-relaxed">
            Готови сме да отговорим на вашите въпроси и да ви помогнем с информирано решение
          </p>
        </div>
      </section>

      <div className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-6">
            <div className="sticky top-32">
              <h2 className="text-2xl font-serif font-semibold text-[#F6F2E8] mb-8">
                Информация за контакт
              </h2>

              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div 
                    key={index}
                    className="flex items-start space-x-4 p-4 bg-[#111111] border border-[#D4AF37]/10 rounded-lg hover:border-[#D4AF37]/30 transition-colors duration-300"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center">
                      {info.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-sm font-semibold text-[#F6F2E8] mb-2">
                        {info.title}
                      </h3>
                      {info.link ? (
                        <a 
                          href={info.link}
                          className="text-[#A9A9A9] hover:text-[#D4AF37] transition-colors duration-300"
                        >
                          {info.details.map((detail, idx) => (
                            <p key={idx} className="text-sm">{detail}</p>
                          ))}
                        </a>
                      ) : (
                        info.details.map((detail, idx) => (
                          <p key={idx} className="text-sm text-[#A9A9A9]">{detail}</p>
                        ))
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Additional Info */}
              <div className="mt-8 p-6 bg-gradient-to-br from-[#111111] to-[#0B0B0B] border border-[#D4AF37]/20 rounded-lg">
                <h3 className="text-lg font-serif font-semibold text-[#F6F2E8] mb-4">
                  Първа консултация безплатно
                </h3>
                <p className="text-sm text-[#A9A9A9] leading-relaxed">
                  Предлагаме безплатна първоначална консултация за всички нови клиенти. 
                  Свържете се с нас днес!
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2">
            <div className="bg-[#111111] border border-[#D4AF37]/10 rounded-2xl p-8 lg:p-12">
              <h2 className="text-2xl font-serif font-semibold text-[#F6F2E8] mb-2">
                Изпратете ни съобщение
              </h2>
              <p className="text-[#A9A9A9] mb-8">
                Попълнете формата и ще се свържем с вас възможно най-скоро
              </p>
              
              <ContactForm formType="contact" />
            </div>
          </div>
        </div>
      </div>

      {/* Map Placeholder */}
      <section className="container-luxury mt-20">
        <div className="bg-[#111111] border border-[#D4AF37]/10 rounded-2xl overflow-hidden h-96 flex items-center justify-center">
          <div className="text-center">
            <MapPin className="w-16 h-16 text-[#D4AF37] mx-auto mb-4" />
            <p className="text-[#A9A9A9] text-lg">
              Карта (Google Maps integration)
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
